import { render, staticRenderFns } from "./EditReligionPage.vue?vue&type=template&id=430dce00&"
import script from "./EditReligionPage.vue?vue&type=script&lang=js&"
export * from "./EditReligionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports